<template>
  <div>
    <div class="ceiling">
      <HomeTop></HomeTop>
      <top-search :showHot="true" type="home"></top-search>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="w-1400">
      <!-- 面包屑 -->
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">产品导航</a></el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 精美搜索组件 -->
      <div class="search-container">
        <div class="search-wrapper">
          <div class="search-input-group">
            <div class="search-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <input v-model="search" type="text" class="search-input" placeholder="搜索产品名称、cas号..."
                   @focus="handleFocus"
                   @input="handleInput"/>
            <div class="search-actions">
              <button v-if="showClear" class="clear-btn" @click="clearSearch" title="清空搜索">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>
              <button class="search-btn" @click="searchList" :class="{ active: showClear || search }">
                <span class="search-text">搜索</span>
                <svg class="search-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-loading="loading">
        <empty v-if="total == 0"/>
        <div class="list">
          <div class="list-item" v-for="item in list" :key="item.id">
            <div class="image-box hit-cursor">
              <img :src="item.image" alt="商品图片" @click="handleClick(item)"/>
            </div>
            <div class="info-box-border">
              <div class="info-box">
                <div class="name-box ellipsis-box">
                  <span class="name ellipsis-box">{{ item.name }}</span>
                  <span class="alias ellipsis-box">{{
                      item.alias_name_en || "--"
                    }}</span>
                </div>
                <div class="alias-name ellipsis-box">
                  中文别名 :{{ item.alias_name || "--" }}
                </div>
              </div>
              <div class="cas-box">
                <span>{{ item.cas_no || "--" }}</span>
                <gradient-button height="30px" @hit="handleQuickPrice(item)">快速询价</gradient-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="total > 0" class="pagination-box">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                         :page-sizes="[20, 50, 100, 200]" :page-size="limit" background
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeTop from "@/components/public/home-top.vue";
import TopSearch from "@/components/public/top-search.vue";
import GradientButton from "@/components/button/gradient-button.vue";
import {getList} from "@/api/modules/home";
import Empty from "@/components/public/empty.vue";

export default {
  name: "ShopList",

  components: {
    HomeTop,
    TopSearch,
    GradientButton,
    Empty,
  },
  data() {
    return {
      id: this.$route.query.id,
      name: this.$route.query.name,
      list: [],
      total: 0,
      page: 1,
      limit: 20,
      search: "",
      showClear: '',
      loading: false,
    };
  },
  computed: {
    isLgoin() {
      return this.$store.getters.isLogin;
    },
  },

  mounted() {
    this.getList();
  },
  methods: {
    handleFocus() {
      this.showClear = true
      this.isFocused = true
    },
    handleInput(e) {
      if (!e.target.value.trim()) {
        this.showClear = false
      } else {
        this.showClear = true
      }
    },
    clearSearch() {
      this.search = ''
      this.showClear = false
      this.page = 1
      this.getList()
    },
    handleClick(item) {
      if (this.isLgoin) {
        this.$router.push({
          path: "/search",
          query: {id: item.id},
        });
      } else {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }

    },
    handleQuickPrice() {
      if (!this.isLgoin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      } else {
          this.$router.push({
            path: "/user/purchase/release",
          });

      }

    },
    searchList(e) {
      // this.search = e.target.value;
      this.getList();
    },
    getList() {
      this.loading = true;
      getList({
        cate_id: this.id,
        page: this.page,
        limit: this.limit,
        keyword: this.search,
      }).then((res) => {
        this.list = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },

    handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
// 精美搜索样式
.search-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
}

.search-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.search-input-group {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 2px solid #e1e5e9;
  border-radius: 50px;
  padding: 8px 8px 8px 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:hover {
    border-color: #409eff;
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
  }

  &:focus-within {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1),
    0 4px 16px rgba(64, 158, 255, 0.15);
    transform: translateY(-1px);
  }
}

.search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #909399;
  margin-right: 12px;
  transition: color 0.3s ease;

  .search-input-group:focus-within & {
    color: #409eff;
  }
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  color: #303133;
  padding: 12px 0;

  &::placeholder {
    color: #c0c4cc;
    transition: color 0.3s ease;
  }

  &:focus::placeholder {
    color: #909399;
  }
}

.search-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f7fa;
  border-radius: 50%;
  color: #909399;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e4e7ed;
    color: #606266;
    transform: scale(1.1);
  }
}

.search-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  background: linear-gradient(135deg, #409eff 0%, #71cbff 100%);
  color: white;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &.active {
    background: linear-gradient(135deg, #82dcff 0%, #61b5ce 100%);
    box-shadow: 0 2px 8px rgba(58, 144, 194, 0.3);

    &:hover {
      box-shadow: 0 4px 16px rgba(58, 156, 194, 0.4);
    }
  }
}

.search-text {
  transition: transform 0.3s ease;
}

.search-arrow {
  transition: transform 0.3s ease;

  .search-btn:hover & {
    transform: translateX(2px);
  }
}

// 搜索结束


.h-top {
  // height: 207px;
  height: 185px;
}

.bread-crumb {
  padding: 20px 0;
}

.ellipsis-box {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 27px;

  .list-item {
    background: #ffffff;
    border-radius: 6px;
    width: 330px;

    .image-box {
      width: 330px;
      height: 280px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .info-box {
      padding: 15px 20px 10px;
      box-sizing: border-box;

      .name-box {
        margin-bottom: 10px;

        .name {
          font-weight: bold;
          font-size: var(--font-size-default-16);
          color: #525666;
          margin-right: 10px;
        }

        .alias {
          font-weight: 400;
          font-size: var(--font-size-default-14);
          color: #7a8199;
        }
      }

      .alias-name {
        font-weight: 400;
        font-size: var(--font-size-default-14);
        color: #7a8199;
        margin-bottom: 10px;
      }
    }

    .info-box-border {
      border: 1px solid #e7eaf3;
    }

    .cas-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #e7eaf3;
      padding: 10px 20px;

      span {
        font-weight: bold;
        font-size: var(--font-size-default-16);
        color: #5f616c;
      }
    }
  }
}

.pagination-box {
  text-align: center;
  padding: 20px 40px;
}
</style>
